<template>
  <form ref="form" onsubmit="return false" v-loading="!initFinished">
    <div
      :id="containerID"
      class="use-deprecated-styles"
      :data-id="id"
      :data-model-name="dataModelName"
      :data-model-attribute="dataModelAttribute"
      data-manage="1"
      data-sub-header-condition="1"
    >
      <section
        class="segmentsSection"
        v-if="templatesReady && editor"
        :class="{ invisible: !initFinished }"
      >
        <div class="segmentsWrapper">
          <div class="segmentConditions" :data-all-time="showAllTime">
            <input
              type="hidden"
              :name="`${dataModelName}[${dataModelAttribute}][operator]`"
              :value="conditions.operator"
            />
            <el-row
              v-if="Object.keys(conditions).length === 1 && noDataAlert"
              style="width: 100%"
            >
              <el-col class="m-bottom-10 p-top-10" :offset="11" :span="11">
                <span class="no-data">
                  {{ $t('Audience_Segment_Form_NoConditions') }}
                </span>
              </el-col>
            </el-row>
            <template
              v-for="(condition, gLoop) in conditions"
              v-if="typeof condition !== 'string'"
            >
              <div class="conditionOuterWrapper">
                <div class="top-relation relation"></div>
                <div class="bottom-relation relation"></div>

                <div
                  class="conditionWrapper"
                  :class="[
                    condition === 'or' ? 'relations_or' : 'relations_and'
                  ]"
                  :data-number="gLoop"
                >
                  <input
                    type="hidden"
                    :name="
                      `${dataModelName}[${dataModelAttribute}][${gLoop}][operator]`
                    "
                    :value="condition.operator"
                  />
                  <el-row
                    v-if="Object.keys(condition).length === 1 && noDataAlert"
                    style="width: 100%"
                  >
                    <el-col class="m-bottom-10" :offset="11" :span="11">
                      <span class="no-data">
                        {{ $t('Audience_Segment_Form_NoConditions') }}
                      </span>
                    </el-col>
                  </el-row>
                  <div
                    v-for="(subcondition, iLoop) in condition"
                    v-if="typeof subcondition !== 'string'"
                    :class="{
                      'no-delete': Object.keys(condition).length < 3
                    }"
                    :key="iLoop"
                    class="condition-row-wrapper"
                  >
                    <span
                      v-html="
                        renderTemplate(twigTemplates.conditionItem, {
                          modelName: dataModelName,
                          modelAttribute: dataModelAttribute,
                          subcondition: subcondition,
                          model: editor.conditionEntity,
                          gLoop: gLoop,
                          iLoop: iLoop,
                          js: true,
                          preview: preview,
                          showAllTime: showAllTime,
                          displayEventProperties: true,
                          displayEventPropertiesAddButton: checkAddPropertyButton(
                            gLoop,
                            iLoop
                          ),
                          displayEventGoalValue: showEventValueProperty,
                          displayEventGoalValueButton: true
                        })
                      "
                    ></span
                    ><span
                      v-if="!preview"
                      @click="removeConditionRow(gLoop, iLoop)"
                      class="remove-row"
                    ></span>
                    <div class="condition-button-wrapper">
                      <condition-button
                        v-model="condition.operator"
                        :readonly="preview || conditionButtonFixed"
                        :callback="rerender"
                        v-if="
                          condition.operator &&
                            getConditionLastKey(condition) > iLoop
                        "
                      />
                    </div>
                    <div
                      class="choices-container"
                      v-if="!preview"
                      :ref="'choices-container-' + gLoop + '-' + iLoop"
                      :tabindex="Math.floor(Math.random() * 100)"
                    >
                      <segment-category-selector
                        :menu-items="menuData"
                        :title="$t('Audience_Segment_Form_Category_Title')"
                        :selected="subcondition ? subcondition[0] : null"
                        :container.sync="
                          $refs['choices-container-' + gLoop + '-' + iLoop]
                        "
                        v-if="menuData && updateFinished"
                      />
                    </div>
                  </div>
                  <div class="addConditionRowWrapper" v-if="!preview">
                    <el-row>
                      <el-col :span="12">
                        <el-button
                          type="primary"
                          plain
                          class="addRowButton"
                          icon="el-icon-circle-plus-outline"
                          @click="addConditionRow(gLoop)"
                          data-qa="add-condition-row-button"
                        >
                          {{ $t('Audience_Segment_Form_AddRow') }}
                        </el-button>
                      </el-col>
                      <el-col :span="12" v-if="!singleLevel">
                        <el-button
                          style="float: right"
                          type="danger"
                          plain
                          v-if="Object.keys(conditions).length > 2"
                          icon="el-icon-delete"
                          @click="removeConditionSection(gLoop)"
                        >
                          {{ $t('Audience_Segment_Form_RemoveSection') }}
                        </el-button>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <div class="condition-button-wrapper">
                <condition-button
                  :key="gLoop"
                  :readonly="preview || conditionButtonFixed"
                  :callback="rerender"
                  style="margin: 0 auto"
                  v-model="conditions.operator"
                  v-if="getConditionLastKey(conditions) > gLoop"
                />
              </div>
            </template>
          </div>
        </div>
        <span v-html="renderTemplate(twigTemplates.previewModal, {})"></span>
      </section>

      <el-row v-if="!preview && !singleLevel">
        <el-col>
          <el-button
            type="primary"
            class="addSectionButton"
            icon="el-icon-circle-plus-outline"
            @click="addConditionSection()"
            data-qa="add-condition-section-button"
            >{{ $t('Audience_Segment_Form_AddSection') }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </form>
</template>

<script>
/* global RELEASE_HASH */

import ConditionsEditor from '@/jquery/widgets/conditionsEditor'
import { baseUrl } from '@/core/helpers'
import { twig } from 'vendor/twig/twig'
import SegmentCategorySelector from '@/modules/audiences/components/SegmentCategorySelector'
import ConditionButton from '@/modules/audiences/components/ConditionButton'
import { TagType, TagTypeNames } from '@/modules/data-manager/enum/TagTypeEnum'
import {
  TagTypeOperatorGroups,
  OperatorGroupMap
} from '@/modules/segment/enum/OperatorGroupEnum'
import _ from 'lodash'

export default {
  components: { ConditionButton, SegmentCategorySelector },
  props: {
    id: {
      required: false
    },
    value: {
      type: Object,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    singleLevel: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Object,
      default: null
    },
    dataModelName: {
      type: String,
      required: true
    },
    dataModelAttribute: {
      type: String,
      required: true
    },
    attributeListDataUrl: {
      type: String,
      default: '/segment/segment/attribute-list-data'
    },
    noDataAlert: {
      type: Boolean,
      default: true
    },
    conditionButtonFixed: {
      type: Boolean,
      default: false
    },
    showAllTime: {
      type: Number,
      default: 0
    },
    showEventValueProperty: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return {
      editor: null,
      containerID: `conditions-editor-${this._uid}`,
      menuData: null,
      conditions: {},
      twigTemplates: {
        conditionHeader: {
          instance: null,
          name: 'condition-header'
        },
        conditionItem: {
          instance: null,
          name: 'condition-item'
        },
        previewModal: {
          instance: null,
          name: 'preview-modal'
        }
      },
      updateFinished: false,
      initFinished: false,
      eventPropLimit: 10,
      eventPropsButtonsDisplay: [],
      isLoadingTagTypes: false
    }
  },

  computed: {
    updateJsonDebounce() {
      return _.debounce(() => {
        this.updateConditionJson()
      }, 500)
    },
    templatesReady() {
      return (
        this.twigTemplates.conditionItem.instance !== null &&
        this.twigTemplates.conditionHeader.instance !== null
      )
    },
    tagOperatorValidationEnabled() {
      return this.$store.state.app.features.tagOperatorValidation
    }
  },

  updated() {
    this.updateFinished = true
  },

  async mounted() {
    let initInterval = setInterval(() => {
      let init = $(`#${this.containerID} .segmentConditions`).data('init')
      if (init) {
        this.initFinished = true
        clearInterval(initInterval)
        setTimeout(async () => {
          await this.loadTagTypesForExistingConditions()
          this.applyOperatorFiltering()
        }, 500)
      }
    }, 100)
    $(this.$refs['form']).on('change', () => {
      this.updateJsonDebounce()
    })
    $(document).on('dropdownselection', () => {
      this.updateJsonDebounce()
    })
    document.addEventListener('dropdownselection', () => {
      this.updateJsonDebounce()
    })

    this.bindPropertiesEvents()

    this.conditions = this.value
    this.defineEventPropsButtons()
    for (const template in this.twigTemplates) {
      await this.loadTwigTemplate(this.twigTemplates[template])
    }
    let menuInterval = setInterval(() => {
      if (this.menu) {
        this.menuData = this.menu
        clearInterval(menuInterval)
        return
      }
      let menuData = $(`#${this.containerID} .segmentConditions`).data(
        'attribute-list'
      )
      if (menuData) {
        this.menuData = menuData
        clearInterval(menuInterval)
      }
    }, 100)

    this.$nextTick(function() {
      this.editor = new ConditionsEditor()
      setTimeout(() => {
        this.editor.init(`#${this.containerID}`, this.attributeListDataUrl)
      })
    })
  },

  beforeDestroy() {
    $(this.$refs['form']).off('change')
    $(document).off('dropdownselection')
    $(document).off('dropdownselection.operatorFilter' + this._uid)
    if (this.initFinished) {
      this.updateConditionJson()
    }
    $('body').undelegate()
  },

  methods: {
    rerender() {
      this.$forceUpdate()
      this.updateJsonDebounce()
    },
    updateConditionJson() {
      if (this.initFinished) {
        this.$emit('input', this.serialize())
      }
    },

    async loadTwigTemplate(segmentTemplate) {
      return twig({
        href: `${baseUrl('/segment/views/segment/templates/')}${
          segmentTemplate.name
        }.twig?v=${RELEASE_HASH}`,
        async: false,
        load: function(template) {
          segmentTemplate.instance = template
        }
      })
    },

    renderTemplate(template, parameters) {
      return template.instance.render(parameters)
    },

    getConditionLastKey(conditions) {
      let maxKey = null
      for (const key of Object.keys(conditions)) {
        if (!isNaN(key)) {
          if (maxKey === null || key > maxKey) {
            maxKey = parseInt(key)
          }
        }
      }
      return maxKey
    },

    addConditionRow(key) {
      let conditions = this.conditions[key]
      let lastIndex = this.getConditionLastKey(conditions)
      let nextIndex = 0
      if (lastIndex !== null) {
        nextIndex = parseInt(lastIndex) + 1
      }
      conditions[nextIndex] = {}
      this.$forceUpdate()
      this.updateFinished = false
    },

    addEventPropertyRow(condIndex, condItemIndex) {
      let nextIndex = 0
      this.conditions = this.value
      if (this.conditions[condIndex] === undefined) {
        this.conditions[condIndex] = {}
      }
      if (this.conditions[condIndex][condItemIndex] === undefined) {
        this.conditions[condIndex][condItemIndex] = {}
      }
      if (this.conditions[condIndex][condItemIndex][7] === undefined) {
        this.conditions[condIndex][condItemIndex][7] = []
      } else {
        let propertySubConditions = []
        Object.keys(this.conditions[condIndex][condItemIndex][7]).forEach(
          key => {
            propertySubConditions.push(
              Object.values(this.conditions[condIndex][condItemIndex][7][key])
            )
          }
        )
        this.conditions[condIndex][condItemIndex][7] = propertySubConditions
        nextIndex = propertySubConditions.length
      }

      let emptyItem = ['', '=', '']
      this.$set(
        this.conditions[condIndex][condItemIndex][7],
        nextIndex,
        emptyItem
      )
      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    addEventValuePropertyRow(condIndex, condItemIndex) {
      this.conditions = this.value
      if (this.conditions[condIndex] === undefined) {
        this.conditions[condIndex] = {}
      }
      if (this.conditions[condIndex][condItemIndex] === undefined) {
        this.conditions[condIndex][condItemIndex] = {}
      }

      this.conditions[condIndex][condItemIndex][8] = ''

      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    removeEventPropertyRow(condIndex, condItemIndex, propIndex) {
      this.conditions = this.value
      delete this.conditions[condIndex][condItemIndex][7][propIndex]
      let propertySubConditions = []
      Object.keys(this.conditions[condIndex][condItemIndex][7]).forEach(key => {
        if (this.conditions[condIndex][condItemIndex][7][key] !== undefined) {
          propertySubConditions.push(
            Object.values(this.conditions[condIndex][condItemIndex][7][key])
          )
        }
      })
      this.conditions[condIndex][condItemIndex][7] = propertySubConditions
      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    removeEventValuePropertyRow(condIndex, condItemIndex) {
      this.conditions = this.value
      this.conditions[condIndex][condItemIndex][8] = null

      this.parseDates()
      this.defineEventPropsButtons()

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    addEventNestedPropertyRow(condIndex, condItemIndex, propertyIndex) {
      this.conditions = this.value
      let emptyItem = ['', '=', '']

      let items = this.conditions[condIndex][condItemIndex][7][propertyIndex][3]
      if (!items) {
        items = []
        this.$set(
          this.conditions[condIndex][condItemIndex][7][propertyIndex],
          3,
          items
        )
      }

      let keys = Object.keys(items)
      this.$set(
        this.conditions[condIndex][condItemIndex][7][propertyIndex][3],
        keys.length ? keys[keys.length - 1] + 1 : 0,
        emptyItem
      )

      this.$set(
        this.conditions[condIndex][condItemIndex][7][propertyIndex],
        2,
        ''
      )

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    removeEventNestedPropertyRow(condIndex, condItemIndex, propIndex, index) {
      this.conditions = this.value
      delete this.conditions[condIndex][condItemIndex][7][propIndex][3][index]
      let propertySubConditions = []
      Object.keys(
        this.conditions[condIndex][condItemIndex][7][propIndex][3]
      ).forEach(key => {
        if (
          this.conditions[condIndex][condItemIndex][7][propIndex][3][key] !==
          undefined
        ) {
          propertySubConditions.push(
            Object.values(
              this.conditions[condIndex][condItemIndex][7][propIndex][3][key]
            )
          )
        }
      })

      this.$set(
        this.conditions[condIndex][condItemIndex][7][propIndex],
        3,
        propertySubConditions
      )

      this.$set(this.conditions[condIndex][condItemIndex][7][propIndex], 2, '')

      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
      this.updateFinished = false
    },

    parseDates() {
      Object.keys(this.conditions).forEach(key => {
        Object.keys(this.conditions[key]).forEach(subKey => {
          if (
            this.conditions[key][subKey][4] !== undefined &&
            ['between', 'between_time'].includes(
              this.conditions[key][subKey][4][1]
            )
          ) {
            let old = this.conditions[key][subKey][4][2]
            if (typeof old === 'string') {
              this.conditions[key][subKey][4][2] = [
                old.split(' to ')[0],
                old.split(' to ')[1]
              ]
            }
          }
        })
      })
    },

    checkAddPropertyButton(condI, condItemI) {
      let shouldBeDisplayed = ['events', 'metric'].includes(
        this.conditions[condI][condItemI][0]
      )
      if (
        this.eventPropsButtonsDisplay[condI] !== undefined &&
        this.eventPropsButtonsDisplay[condI][condItemI] !== undefined
      ) {
        shouldBeDisplayed = this.eventPropsButtonsDisplay[condI][condItemI]
      }
      return shouldBeDisplayed
    },

    defineEventPropsButtons() {
      Object.keys(this.conditions).forEach(key => {
        Object.keys(this.conditions[key]).forEach(nestedKey => {
          if (this.eventPropsButtonsDisplay[key] === undefined) {
            this.eventPropsButtonsDisplay[key] = []
          }
          this.eventPropsButtonsDisplay[key][nestedKey] = [
            'events',
            'tags_attribute'
          ].includes(this.conditions[key][nestedKey][0])
          if (this.conditions[key][nestedKey][7] !== undefined) {
            this.eventPropsButtonsDisplay[key][nestedKey] =
              Object.keys(this.conditions[key][nestedKey][7]).length <
              this.eventPropLimit
          }
        })
      })
    },

    removeConditionSection(key) {
      this.$emit('input', this.serialize())
      this.$nextTick(() => {
        this.conditions = this.value
        this.$delete(this.conditions, key)
        this.$forceUpdate()
        this.$nextTick(() => {
          this.editor.initDOM()
          this.updateConditionJson()
        })
      })
    },

    removeConditionRow(gLoop, iLoop) {
      this.conditions = this.value
      if (
        this.getConditionLastKey(this.conditions[gLoop]) === 0 &&
        !this.singleLevel
      ) {
        delete this.conditions[gLoop]
      } else {
        delete this.conditions[gLoop][iLoop]
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        this.editor.initDOM()
        this.updateConditionJson()
      })
    },

    addConditionSection() {
      let lastIndex = this.getConditionLastKey(this.conditions)
      let nextIndex = 0
      if (lastIndex !== null) {
        nextIndex = parseInt(lastIndex) + 1
      }
      this.conditions[nextIndex] = { '0': {}, operator: 'AND' }
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },

    serialize() {
      let form = this.serializedForm()
      if (
        form &&
        form[this.dataModelName] &&
        form[this.dataModelName].conditions
      ) {
        for (let sectionKey in form[this.dataModelName].conditions) {
          let section = form[this.dataModelName].conditions[sectionKey]
          for (let rowKey in section) {
            if (this.isDateRange(section, rowKey)) {
              let datesArr = section[rowKey][4][2].split(' to ')
              section[rowKey][4] = [
                section[rowKey][4][0],
                section[rowKey][4][1],
                datesArr
              ]
            }
          }
        }
      }

      if (form.hasOwnProperty(this.dataModelName)) {
        return form[this.dataModelName][this.dataModelAttribute]
      }
    },

    validateConditions() {
      const errors = []

      const $conditionRows = $(`#${this.containerID} .conditionRow`)

      $conditionRows.each((index, row) => {
        const $row = $(row)
        const $attributeSelect = $row.find('.jsEntityName')
        const selectedAttribute = $attributeSelect.val()
        const rowNumber = index + 1

        if (!selectedAttribute || selectedAttribute === '') {
          errors.push({
            type: 'missing_attribute',
            message: this.$t('Audience_Segment_Validation_AttributeRequired', {
              row: rowNumber
            })
          })
        } else {
          const conditionType = $row.attr('data-condition-type')
          if (conditionType && this.editor && this.editor.conditionEntity) {
            const params = this.editor.conditionEntity.paramList(conditionType)

            if (params && params.value) {
              const $valueField = $row.find('.jsEntityValue')
              const value = $valueField.val()
              const $compareField = $row.find('.jsEntityCompare')
              const operator = $compareField.val()

              const operatorsWithoutValue = [
                'not set',
                'is set',
                'true',
                'false',
                'unattributed'
              ]

              const attributeName = $attributeSelect
                .find('option:selected')
                .text()
                .trim()

              if (
                !operatorsWithoutValue.includes(operator) &&
                (!value || value === '')
              ) {
                errors.push({
                  type: 'missing_value',
                  message: this.$t(
                    'Audience_Segment_Validation_ValueRequired',
                    {
                      row: rowNumber,
                      attribute: attributeName
                    }
                  )
                })
              } else if (value && conditionType === 'tags_attribute') {
                const tagType = $valueField.data('type')

                if (tagType !== undefined && tagType !== null) {
                  const parsedTagType = parseInt(tagType)
                  const additionalOperator = $row
                    .find('.jsEntityAdditionalOperatorCompare')
                    .val()
                  const additionalValue = $row
                    .find('.jsEntityAdditionalOperatorValue')
                    .val()

                  const typeError = this.validateValueType(
                    additionalValue,
                    parsedTagType,
                    additionalOperator
                  )

                  if (typeError) {
                    errors.push({
                      type: 'invalid_value_type',
                      message: this.$t(
                        'Audience_Segment_Validation_InvalidValueType',
                        {
                          row: rowNumber,
                          attribute: value,
                          expectedType: TagTypeNames[parsedTagType]
                        }
                      )
                    })
                  }
                }
              }
            }
          }
        }
      })

      return errors
    },

    validateValueType(value, tagType, operator) {
      if (!value || value === '') {
        return false
      }

      const validBooleans = [
        '0',
        '1',
        'true',
        'false',
        'yes',
        'no',
        'y',
        'n',
        't',
        'f'
      ]

      switch (tagType) {
        case TagType.NUMBER:
        case TagType.UNENFORCED_NUMBER:
        case TagType.INTEGER:
          return value
            .split(',')
            .map(v => v.trim())
            .filter(v => v !== '')
            .some(v => isNaN(v))
        case TagType.BOOLEAN:
          return !validBooleans.includes(value.toLowerCase())
        case TagType.DATE:
          return (
            !isFinite(value) &&
            !/^\d{4}-\d{2}-\d{2}$/.test(value) &&
            isNaN(Date.parse(value))
          )
        case TagType.DATETIME:
          return (
            !isFinite(value) &&
            !/^\d{4}-\d{2}-\d{2}/.test(value) &&
            isNaN(Date.parse(value))
          )
        case TagType.ARRAY: {
          const allowedArrayOperators = [
            'is set',
            'not set',
            'contains object',
            'not contains object',
            'contains value',
            'not contains value',
            'contains any of',
            'contains none of',
            'contains item',
            'contains item with property'
          ]
          return !allowedArrayOperators.includes(operator)
        }
        case TagType.OBJECT: {
          const allowedObjectOperators = [
            'is set',
            'not set',
            'contains property'
          ]
          return !allowedObjectOperators.includes(operator)
        }
        default:
          return false
      }
    },

    isDateRange(section, rowKey) {
      return (
        typeof section[rowKey] === 'object' &&
        undefined !== section[rowKey][4] &&
        (section[rowKey][0] === 'created_time' ||
          section[rowKey][4][0] === 'date') &&
        (section[rowKey][4][1] === 'between' ||
          section[rowKey][4][1] === 'between_time')
      )
    },

    serializedForm() {
      return $(this.$refs['form']).serializeJSON()
    },

    filterOptionsWithoutSelection(
      $operatorSelect,
      allowedGroups,
      groupTranslations
    ) {
      const self = this
      $operatorSelect.find('optgroup').each(function() {
        const $optgroup = $(this)
        const label = $optgroup.attr('label')

        if (self.isGroupAllowed(label, allowedGroups, groupTranslations)) {
          self.showOptgroup($optgroup)
        } else {
          self.hideOptgroup($optgroup)
        }
      })
    },

    buildGroupTranslations($operatorSelect) {
      const groupTranslations = {}
      $operatorSelect.find('optgroup').each(function() {
        const $optgroup = $(this)
        const label = $optgroup.attr('label')

        const firstOperator = $optgroup.find('option:first').val()
        if (!firstOperator) {
          return
        }

        const groupType = OperatorGroupMap[firstOperator]
        if (groupType && !groupTranslations[groupType]) {
          groupTranslations[groupType] = label
        }
      })
      return groupTranslations
    },

    isGroupAllowed(label, allowedGroups, groupTranslations) {
      for (const group of allowedGroups) {
        if (groupTranslations[group] === label) {
          return true
        }
      }
      return false
    },

    showOptgroup($optgroup) {
      $optgroup.show()
      $optgroup
        .find('option')
        .prop('disabled', false)
        .removeClass('incompatible-operator')
    },

    hideOptgroup($optgroup) {
      $optgroup.hide()
      $optgroup.find('option').prop('disabled', true)
    },

    showOptgroupWithIncompatibleSelection($optgroup, currentValue) {
      $optgroup.show()
      $optgroup
        .find('option[value="' + currentValue + '"]')
        .prop('disabled', false)
        .addClass('incompatible-operator')
      $optgroup
        .find('option')
        .not('[value="' + currentValue + '"]')
        .prop('disabled', true)
    },

    isCurrentSelectionIncompatible(
      $currentOption,
      allowedGroups,
      groupTranslations
    ) {
      const currentGroup = $currentOption.parent('optgroup').attr('label')

      if (!currentGroup) {
        return false
      }

      return !this.isGroupAllowed(
        currentGroup,
        allowedGroups,
        groupTranslations
      )
    },

    filterOptgroupsWithSelection(
      $operatorSelect,
      $currentOption,
      allowedGroups,
      groupTranslations,
      currentWillBeHidden
    ) {
      const currentValue = $currentOption.val()
      const currentGroup = $currentOption.parent('optgroup').attr('label')
      const self = this

      $operatorSelect.find('optgroup').each(function() {
        const $optgroup = $(this)
        const label = $optgroup.attr('label')

        if (self.isGroupAllowed(label, allowedGroups, groupTranslations)) {
          self.showOptgroup($optgroup)
        } else {
          if (currentWillBeHidden && $optgroup.attr('label') === currentGroup) {
            self.showOptgroupWithIncompatibleSelection($optgroup, currentValue)
          } else {
            self.hideOptgroup($optgroup)
          }
        }
      })
    },

    updateIncompatibilityWarning($operatorSelect, isIncompatible, tagType) {
      if (isIncompatible) {
        $operatorSelect.addClass('has-incompatible-selection')
        const typeName = this.getTagTypeName(tagType)
        $operatorSelect.attr(
          'title',
          `Warning: This operator is not compatible with ${typeName} attributes. Please select a compatible operator.`
        )
      } else {
        $operatorSelect.removeClass('has-incompatible-selection')
        $operatorSelect.removeAttr('title')
      }
    },

    resetOperatorFiltering($operatorSelect) {
      if (!$operatorSelect || !$operatorSelect.length) {
        return
      }

      const self = this
      $operatorSelect.find('optgroup').each(function() {
        self.showOptgroup($(this))
      })

      $operatorSelect.removeClass('has-incompatible-selection')
      $operatorSelect.removeAttr('title')

      // if the current selected value is enabled then we shouldn't do anything
      const $selectedOption = $operatorSelect.find('option:selected')
      if (!$selectedOption.prop('disabled')) {
        return
      }

      // Select the first enabled option
      const $firstOption = $operatorSelect.find('option:not(:disabled):first')
      if ($firstOption.length && $operatorSelect.val() !== $firstOption.val()) {
        $operatorSelect.val($firstOption.val()).trigger('change')
      }
    },

    filterOperatorsByTagType($operatorSelect, tagType) {
      if (!this.tagOperatorValidationEnabled) {
        return
      }

      if (!$operatorSelect || !$operatorSelect.length || isNaN(tagType)) {
        return
      }

      const allowedGroups = TagTypeOperatorGroups[tagType] || []
      const groupTranslations = this.buildGroupTranslations($operatorSelect)
      const $currentOption = $operatorSelect.find('option:selected')

      if (!$currentOption.length) {
        this.filterOptionsWithoutSelection(
          $operatorSelect,
          allowedGroups,
          groupTranslations
        )
        return
      }

      const currentWillBeHidden = this.isCurrentSelectionIncompatible(
        $currentOption,
        allowedGroups,
        groupTranslations
      )

      this.filterOptgroupsWithSelection(
        $operatorSelect,
        $currentOption,
        allowedGroups,
        groupTranslations,
        currentWillBeHidden
      )

      this.updateIncompatibilityWarning(
        $operatorSelect,
        currentWillBeHidden,
        tagType
      )
    },

    getTagTypeName(tagType) {
      return TagTypeNames[tagType] || 'this type of'
    },

    bindPropertiesEvents() {
      let el = $(`#${this.containerID}`)
      el.delegate('.addEventPropertyButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.addEventPropertyButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        this.addEventPropertyRow(conditionIndex, conditionItemIndex)
      })
      el.delegate('.removeEventPropertyButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.removeEventPropertyButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        let conditionItemPropertyIndex = elem.data('property-index')
        this.removeEventPropertyRow(
          conditionIndex,
          conditionItemIndex,
          conditionItemPropertyIndex
        )
      })
      el.delegate('.addEventNestedPropertyButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.addEventNestedPropertyButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        let propertyIndex = elem.data('property-index')
        this.addEventNestedPropertyRow(
          conditionIndex,
          conditionItemIndex,
          propertyIndex
        )
      })
      el.delegate('.removeEventNestedPropertyButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.removeEventNestedPropertyButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        let propertyIndex = elem.data('property-index')
        let nestedPropertyIndex = elem.data('nested-property-index')
        this.removeEventNestedPropertyRow(
          conditionIndex,
          conditionItemIndex,
          propertyIndex,
          nestedPropertyIndex
        )
      })
      el.delegate('.conditionRow input', 'keyup', event => {
        this.updateConditionJson()
      })
      el.delegate('.addEventGoalValueButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.addEventGoalValueButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        this.addEventValuePropertyRow(conditionIndex, conditionItemIndex)
      })
      el.delegate('.removeEventGoalValueButton', 'click', event => {
        event.preventDefault()
        let elem = $(event.target).closest('.removeEventGoalValueButton')
        let conditionIndex = elem.data('condition-index')
        let conditionItemIndex = elem.data('condition-item-index')
        this.removeEventValuePropertyRow(conditionIndex, conditionItemIndex)
      })

      el.delegate('.jsEntityValue.jsAutocomplete', 'change', async () => {
        await this.loadTagTypesForExistingConditions()
        this.applyOperatorFiltering()
      })

      $(document).on('dropdownselection.operatorFilter' + this._uid, () => {
        setTimeout(() => {
          this.applyOperatorFiltering()
        }, 200)
      })

      el.delegate('.jsEntityAdditionalOperatorCompare', 'change', event => {
        const $operatorSelect = $(event.target)
        const $row = $operatorSelect.closest('.conditionRow')
        const conditionType = $row.data('condition-type')

        if (conditionType === 'tags_attribute') {
          const $tagInput = $row.find('.jsEntityValue.jsAutocomplete')

          if ($tagInput.length > 0) {
            const tagType = $tagInput.data('type')

            if (tagType !== undefined && tagType !== null) {
              this.filterOperatorsByTagType($operatorSelect, parseInt(tagType))
            }
          }
        }
      })
    },

    async fetchTagTypesByTitles(tagTitles, projectId) {
      const tagPromises = tagTitles.map(tagTitle =>
        fetch(
          `/api/tag/tag/autocomplete?project_id=${projectId}&attribute=1&show_aliases=0&term=${encodeURIComponent(
            tagTitle
          )}`,
          {
            headers: {
              Accept: 'application/json'
            }
          }
        )
          .then(r => {
            if (r.ok) {
              return r.json()
            }
            if (r.status === 404) {
              return null
            }
            throw new Error(`HTTP ${r.status}`)
          })
          .catch(() => null)
      )

      return Promise.all(tagPromises)
    },

    processTagTypeResults(results, tagTitles) {
      const tagMap = {}

      results.forEach((data, index) => {
        if (data && Array.isArray(data) && data.length > 0) {
          let tag = data.find(
            item =>
              item.value &&
              item.value.toLowerCase() === tagTitles[index].toLowerCase()
          )

          if (!tag) {
            tag = data.find(item => !item.disabled && item.id) || data[0]
          }

          if (tag && tag.type !== undefined) {
            tagMap[tagTitles[index]] = {
              type: tag.type,
              value: tag.value,
              id: tag.id
            }
          }
        }
      })

      return tagMap
    },

    getProjectId() {
      return (
        (this.$store &&
          this.$store.state &&
          this.$store.state.project &&
          this.$store.state.project.id) ||
        window.projectId ||
        new URLSearchParams(window.location.search).get('project_id')
      )
    },

    async loadTagTypesForExistingConditions() {
      if (this.isLoadingTagTypes) {
        return
      }

      this.isLoadingTagTypes = true

      try {
        const el = $(`#${this.containerID}`)

        if (!el.length) {
          return
        }

        const tagsToFetch = []

        el.find('.conditionRow').each((_index, row) => {
          const $row = $(row)
          const conditionType = $row.data('condition-type')

          if (conditionType === 'tags_attribute') {
            const $tagInput = $row.find('.jsEntityValue.jsAutocomplete')

            if ($tagInput.length > 0) {
              const tagType = $tagInput.data('type')
              const tagValue = $tagInput.val()

              if (
                tagValue &&
                (tagType === undefined || tagType === null || tagType === '')
              ) {
                tagsToFetch.push({
                  input: $tagInput,
                  value: tagValue
                })
              }
            }
          }
        })

        if (tagsToFetch.length > 0) {
          const uniqueTags = [...new Set(tagsToFetch.map(t => t.value))]
          const projectId = this.getProjectId()

          if (!projectId) {
            console.warn(
              'Tag operator validation: No project ID found, skipping tag type lookup'
            )
            return
          }

          const results = await this.fetchTagTypesByTitles(
            uniqueTags,
            projectId
          )
          const tagMap = this.processTagTypeResults(results, uniqueTags)
          tagsToFetch.forEach(({ input, value }) => {
            const result = tagMap[value]
            if (result !== undefined) {
              input.val(result.value)
              input.data('type', result.type)
              input.data('selected-value', result.value)
            }
          })
        }
      } catch (error) {
        console.error('Error fetching tag types:', error)
      } finally {
        this.isLoadingTagTypes = false
      }
    },

    async applyOperatorFiltering() {
      if (!this.tagOperatorValidationEnabled) {
        return
      }

      const el = $(`#${this.containerID}`)

      if (!el.length) {
        return
      }

      const rows = el.find('.conditionRow').toArray()

      for (const row of rows) {
        const $row = $(row)
        const conditionType = $row.data('condition-type')

        if (conditionType === 'tags_attribute') {
          const $tagInput = $row.find('.jsEntityValue.jsAutocomplete')

          if ($tagInput.length > 0) {
            const tagType = $tagInput.data('type')
            const $operatorSelect = $row.find(
              '.jsEntityAdditionalOperatorCompare'
            )

            if ($operatorSelect.length > 0) {
              if (tagType !== undefined && tagType !== null && tagType !== '') {
                this.filterOperatorsByTagType(
                  $operatorSelect,
                  parseInt(tagType)
                )
              } else {
                this.resetOperatorFiltering($operatorSelect)
              }
            }
          }
        }
      }
    }
  },
  watch: {
    menuData() {
      this.$nextTick(function() {
        setTimeout(() => {
          this.editor.initDOM()
          if (this.preview) {
            setTimeout(() => {
              $('input,select')
                .prop('readonly', true)
                .on('mousedown', e => {
                  e.preventDefault()
                })
            }, 100)
          }
          setTimeout(async () => {
            await this.loadTagTypesForExistingConditions()
            this.applyOperatorFiltering()
          }, 600)
        }, 500)
      })
    }
  }
}
</script>

<style scoped>
.addConditionRowWrapper {
  border-top: 1px solid #d9dada;
  padding: 14px 14px 5px;
}
.condition-button-wrapper {
  margin: 11px 20px;
}
.no-data {
  font-size: 14px;
}
.segmentsWrapper {
  border: 0 none !important;
}
.segmentConditions {
  padding: 0 !important;
}
.conditionOuterWrapper {
  padding: 0 !important;
  position: relative;
}
.addRowButton {
  font-weight: normal !important;
}
>>> .addEventPropertyButton,
>>> .addEventGoalValueButton {
  font-weight: normal !important;
  margin-bottom: 8px;
  margin-left: 0px;
  margin-right: 5px;
}
>>> .addEventNestedPropertyButton {
  font-weight: normal !important;
  border: none;
  padding-left: 0;
  padding-right: 0;
  margin-top: 1px;
}
>>> .addEventNestedPropertyButton:hover {
  background-color: unset !important;
  color: #1d87c8 !important;
}
>>> .removeEventPropertyButton,
>>> .removeEventGoalValueButton,
>>> .removeEventNestedPropertyButton {
  font-weight: normal !important;
  color: #a7acba !important;
  border: none;
  padding-left: 0;
  padding-right: 0;
  margin-top: 1px;
}
>>> .removeEventPropertyButton:hover,
>>> .removeEventGoalValueButton:hover,
>>> .removeEventNestedPropertyButton:hover {
  background-color: unset !important;
  color: #a7acba !important;
}
.addSectionButton {
  border: 1px solid #d9dada;
  background: #f8fafc;
  width: 100%;
  color: #1d87c8;
  font-weight: normal;
  height: 46px;
  margin-top: 20px;
}
>>> .no-delete .delete {
  display: none;
}
form {
  min-height: 160px;
}
.invisible {
  visibility: hidden;
}
>>> .el-loading-spinner {
  top: 150px;
}

>>> .item-text {
  width: fit-content;
  height: fit-content;
}

>>> .iconp-IconBellStar:before {
  content: url('../../img/icon/icon-bell-star.svg');
  scale: 1.08;
}

>>> .jsEntityName {
  width: 160px !important;
}

>>> .jsEntityEventPropertiesOperatorName {
  width: 160px !important;
}

>>> .jsEntityEventNestedPropertiesList {
  padding-left: 332px;
}

>>> .jsEntityEventNestedPropertiesLabel {
  position: absolute;
  left: 0;
  width: 332px;
  text-align: right;
  color: #7e8596;
  height: 38px;
  line-height: 38px;
}

>>> .jsEntityEventPropertiesWrapper {
  padding-left: 166px;
}

>>> .jsEntityEventPropertiesLabel {
  position: absolute;
  left: 0;
  width: 166px;
  text-align: right;
  color: #7e8596;
  height: 38px;
  line-height: 38px;
}

>>> .jsEntityEventPropertiesWrapper.jsEntityEventPropertyValueNameWrapper {
  padding-bottom: 8px;

  .text {
    line-height: 38px;
  }

  input[type='text'] {
    width: 250px;
  }
}
</style>

<style>
/* Non-scoped style to ensure it applies to dynamically rendered content */

/* Incompatible operator selection warning */
select.has-incompatible-selection {
  border: 2px solid #e6a23c !important;
  background-color: #fdf6ec !important;
}

option.incompatible-operator {
  color: #e6a23c !important;
  font-weight: bold;
}

option.incompatible-operator::before {
  content: '⚠ ';
}
</style>



// WEBPACK FOOTER //
// src/common/components/ConditionsEditor.vue